export enum BidAssignee {
  PHARMA = 'PHARMA',
  PAYER = 'PAYER'
}
